import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import Portal from './Portal';
import PendingAccount from '../components/PendingAccount/PendingAccount';

const LandingPage = () => {
  const [showPortal, setShowPortal] = useState();
  const { portalStatus } = useSelector((state) => state.user.user);

  useEffect(() => {
    if (portalStatus === 'pending') {
      setShowPortal(false);
    } else {
      setShowPortal(true);
    }
  }, [portalStatus]);

  if (!showPortal) {
    return <PendingAccount />;
  }

  return <Portal />;
};

export default LandingPage;
